import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './Home.css';

const Home = () => {
  const { user } = useAuth();

  return (
    <div className="home">
      <div className="hero">
        <h1>🧶 TinyHappyProjects</h1>
        <p className="subtitle">Track your crochet amigurumi project progress</p>
        <p className="description">
          Organize your projects, visualize your progress, and celebrate your completed creations.
        </p>
        {user ? (
          <Link to="/dashboard" className="btn btn-primary">
            Go to Dashboard
          </Link>
        ) : (
          <div className="hero-actions">
            <Link to="/register" className="btn btn-primary">
              Get Started
            </Link>
            <Link to="/login" className="btn btn-secondary">
              Login
            </Link>
          </div>
        )}
      </div>

      <div className="features">
        <div className="feature-card">
          <h3>📊 Track Progress</h3>
          <p>Monitor your projects from start to finish with visual progress charts.</p>
        </div>
        <div className="feature-card">
          <h3>📸 Image Gallery</h3>
          <p>Upload photos of your beautiful amigurumi creations.</p>
        </div>
        <div className="feature-card">
          <h3>✅ Stay Organized</h3>
          <p>Keep track of todo, in-progress, and completed projects all in one place.</p>
        </div>
      </div>
    </div>
  );
};

export default Home;
